import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import { currencyFormattedNumber } from '../../lib/numberFormatter';

const PendingAmountLabel = ({ currency, otherFunds, pendingAmount, errorMessage }) => {
  const pendingAmountLabel = useMemo(() => {
    const formattedPendingAmount = currencyFormattedNumber(currency, pendingAmount);
    if (otherFunds === 0 && pendingAmount !== 0) {
      return `You still need another ${formattedPendingAmount} to cover your costs.`;
    }

    if (pendingAmount !== 0) {
      const formattedOtherFunds = currencyFormattedNumber(currency, otherFunds);
      return `Earlier, you told us how you'll cover ${formattedOtherFunds} of your costs. You still need another ${formattedPendingAmount} to cover your costs.`;
    }

    if (errorMessage === null) {
      return null;
    }

    return null;
  }, [pendingAmount, otherFunds, currency, errorMessage]);

  return <div className="row-spacer">{pendingAmountLabel}</div>;
};

PendingAmountLabel.propTypes = {
  currency: PropTypes.string.isRequired,
  otherFunds: PropTypes.number.isRequired,
  pendingAmount: PropTypes.number.isRequired,
  errorMessage: PropTypes.string,
};

PendingAmountLabel.defaultProps = {
  errorMessage: null,
};

export default PendingAmountLabel;
